import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "../style/header.css";
import { useTranslation } from "react-i18next";
import { isTokenValid } from "../api/config";

const Header = () => {
  const { t, i18n } = useTranslation();
  const [lang, setLang] = useState(i18n.language);
  const navigate = useNavigate();
  const token = JSON.parse(localStorage.getItem("cardsToken"));

  const toggleLang = () => {
    const nextLang = lang === "ar" ? "en" : "ar";
    i18n.changeLanguage(nextLang);
    setLang(nextLang);
    localStorage.setItem("lang", nextLang);

    const nextDir = nextLang === "ar" ? "rtl" : "ltr";
    document.documentElement.dir = nextDir;
    document.body.className = nextDir;
  };

  const onClick = (e) => {
    e.preventDefault();
    const targetPath = e.currentTarget.getAttribute("href");
    if (isTokenValid(token)) {
      navigate(targetPath);
    } else {
      localStorage.removeItem("cardsToken");
      navigate('/user/login');
    }
    const closeBtn = document.querySelector(".btn-close");
    if (closeBtn) {
      closeBtn.click();
    }
  };

  const handleLogout = () => {
    localStorage.removeItem("cardsToken");
    navigate('/user/login');
    const closeBtn = document.querySelector(".btn-close");
    if (closeBtn) closeBtn.click();
  };

  return (
    <nav className="navbar navbar-dark bg-dark fixed-top d-block d-sm-none">
      <div className="container-fluid">
        <Link onClick={onClick} className="navbar-brand text-capitalize fw-bold fs-4" to="/"> 
          {t('HEADING.WEBSITEBRAND')} 
        </Link>
        
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="offcanvas"
          data-bs-target="#offcanvasDarkNavbar"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div
          className="offcanvas offcanvas-end text-bg-dark"
          tabIndex="-1"
          id="offcanvasDarkNavbar"
        >
          <div className="offcanvas-header">
            <Link onClick={onClick} className="navbar-brand text-capitalize fw-bold fs-4" to="/"> 
              {t('HEADING.WEBSITEBRAND')} 
            </Link>
            <button
              type="button"
              className="btn-close btn-close-white" 
              data-bs-dismiss="offcanvas"
            ></button>
          </div>

          <div className="offcanvas-body d-flex flex-column">
            <ul className="navbar-nav justify-content-start flex-grow-0 pe-3">
              <li className="nav-item">
                <Link onClick={onClick} className="nav-link active" to="/"> 
                  {t("NAVBER.HOME")} 
                </Link>
              </li>
              
              {/* PCARD Dropdown */}
              <li className="nav-item dropdown">
                <button 
                  className="nav-link dropdown-toggle btn btn-link shadow-none border-0 text-start" 
                  type="button"
                  data-bs-toggle="dropdown"
                >
                  {t("NAVBER.PCARD")}
                </button>
                <ul className="dropdown-menu dropdown-menu-dark">
                  <li><Link onClick={onClick} className="dropdown-item" to="/addpcard">{t("NAVBER.ADDCARD")}</Link></li>
                  <li><Link onClick={onClick} className="dropdown-item" to="/pcards">{t("NAVBER.CARDS")}</Link></li>
                </ul>
              </li>

              {/* GCARD Dropdown */}
              <li className="nav-item dropdown">
               <button 
                  className="nav-link dropdown-toggle btn btn-link shadow-none border-0 text-start" 
                  type="button"
                  data-bs-toggle="dropdown"
                >
                  {t("NAVBER.GCARD")}
                </button>
                <ul className="dropdown-menu dropdown-menu-dark">
                  <li><Link onClick={onClick} className="dropdown-item" to="/addgcard">{t("NAVBER.ADDCARD")}</Link></li>
                  <li><Link onClick={onClick} className="dropdown-item" to="/gcards">{t("NAVBER.CARDS")}</Link></li>
                </ul>
              </li>

              <li className="nav-item">
                <button 
                  onClick={handleLogout}
                  className="btn btn-danger w-100 mt-3 text-capitalize"
                >
                  {t("NAVBER.LOGOUT")}
                </button>
              </li>
            </ul>

            {/* Language Switcher at the bottom */}
            <div className="mt-auto w-100 pb-3">
              <button
                onClick={toggleLang}
                className="btn w-100"
                style={{
                  backgroundColor: "#1e90ff",
                  color: "white",
                  fontSize: 18,
                  fontWeight: "bold"
                }}
              >
                {lang === "ar" ? "English" : "العربية"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Header;